/**
 * The categories offered by the feedback dialog.
 *
 * Extracted out of `FeedbackDialog` so the User Guide's feedback
 * chapter can show the same four options in the same colours the
 * reader will actually see, instead of a hand-kept copy that drifts
 * the first time someone adds a category.
 */

import type { FeedbackCategory } from '../api/feedback';

export interface FeedbackCategoryDef {
  value: FeedbackCategory;
  label: string;
  emoji: string;
  activeBg: string;
  activeBorder: string;
  activeText: string;
  /** Prompt shown in the message field once this category is picked. */
  placeholder: string;
}

export const FEEDBACK_CATEGORIES: FeedbackCategoryDef[] = [
  {
    value: 'idea',
    label: 'Idea',
    emoji: '\u{1F4A1}',
    activeBg: 'rgba(240, 200, 112, 0.18)',
    activeBorder: 'rgba(240, 200, 112, 0.65)',
    activeText: '#8b6b1a',
    placeholder: 'A feature that would make the platform more useful?',
  },
  {
    value: 'bug',
    label: 'Bug',
    emoji: '\u{1F41B}',
    activeBg: 'rgba(243, 168, 168, 0.18)',
    activeBorder: 'rgba(243, 168, 168, 0.65)',
    activeText: '#a13434',
    placeholder: 'Something off in a chart, number, or page? Tell us what you saw.',
  },
  {
    value: 'praise',
    label: 'Love',
    emoji: '\u2764\uFE0F',
    activeBg: 'rgba(241, 179, 194, 0.22)',
    activeBorder: 'rgba(241, 179, 194, 0.7)',
    activeText: '#9b2a48',
    placeholder: "Tell us what's working \u2014 it makes our day.",
  },
  {
    value: 'other',
    label: 'Other',
    emoji: '\u{1F4AC}',
    activeBg: 'rgba(187, 140, 63, 0.14)',
    activeBorder: 'rgba(187, 140, 63, 0.45)',
    activeText: '#8e6a2a',
    placeholder: "What's on your mind?",
  },
];
